.tableWrapper {
    position: relative;
    width: 100%;
    overflow-x: auto;
    margin: var(--legacy-base) 0;

    .tableWrapper:last-child {
        margin-bottom: 0;
    }
}

.table {
    border-collapse: collapse;
    border-spacing: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    color: inherit;
    /* margin: var(--legacy-base) 0; */
}

.table th {
    background-color: rgb(227, 238, 242);
    border: 1px solid rgb(158, 160, 165);
    padding: calc(var(--legacy-base) * 0.5);
    text-align: left;
    vertical-align: bottom;
    word-break: keep-all;
    font-weight: 700;
}

.table td {
    background-color: transparent;
    border: 1px solid rgb(158, 160, 165);
    padding: calc(var(--legacy-base) * 0.5);
    vertical-align: top;
    word-break: keep-all;
}

.table thead td:empty {
    border: none;
}

.table [data-align="center"] {
    text-align: center;
}
.table [data-align="right"] {
    text-align: right;
}
.table [data-align="left"] {
    text-align: left;
}

.table p:first-child {
    margin-top: 0;
}
.table p:last-child {
    margin-bottom: 0;
}

.tableNoBorder,
.tableNoBorder th,
.tableNoBorder td {
    border: none;
}

.fullscreenButton {
    margin: 0 0 calc(var(--legacy-base) * 0.5);
}
